import { LABELS } from '../constants';
import TrendLineChart, { StatCardConfig, TrendSeries, TrendStats } from './TrendLineChart';

interface TrendBySectorProps {
  series: TrendSeries[];
  stats: TrendStats;
  isLoading: boolean;
  type?: string;
}

const TrendBySector = ({ series, stats, isLoading, type }: TrendBySectorProps) => {
  const label = LABELS[type ?? ''] || type || "Alerts"
  const cards: StatCardConfig[] = [
    { label: `Total ${label}`, value: (stats.totalAlerts ?? 0).toLocaleString('en-US'), subtitle: stats.totalSubtitle, trend: stats.totalTrend, tooltip: `Total ${label} in the selected period` },
    { label: 'Peak Day', value: stats.peakDay ? new Date(stats.peakDay + 'T00:00:00').toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : '-', subtitle: stats.peakDaySubtitle, tooltip: `Day with the highest number of ${label.toLowerCase()}` },
    // { label: 'Avg/Day', value: (stats.avgPerDay ?? 0).toLocaleString('en-US'), subtitle: stats.avgSubtitle, trend: stats.avgTrend, tooltip: `Average ${label.toLowerCase()} per day in the selected period` },
    { label: `Top Sector`, value: stats?.topSector ?? '-', subtitle: stats.topSubtitle, tooltip: `Top sector with the most ${type}` },
  ]
  return (
  <TrendLineChart
    title={`Trends by Sector - ${label}`}
    series={series}
    stats={stats}
    cards={cards}
    isLoading={isLoading}
    topLabel="Top Sector"
    topValue={stats?.topSector ?? '-'}
  />
)};

export default TrendBySector;
